<div class="execution-details-container">
  <div class="header-row">
    <h3>
      <ng-container *ngIf="executionId; else baseTitle">
        Execution Results - #{{ executionId }}
        <span *ngIf="executionDescription"> ({{ executionDescription }})</span>
      </ng-container>
      <ng-template #baseTitle>Execution Results</ng-template>
    </h3>
    <div class="header-actions">
      <span *ngIf="loading" class="loading-indicator">
        <i class="pi pi-spinner pi-spin"></i>
        Loading...
      </span>
      <span class="p-input-icon-left search-input">
        <i class="pi pi-search"></i>
        <input id="detailSearch"
               pInputText type="text"
               [ngModel]="filterText"
               (input)="dt.filterGlobal($any($event.target).value, 'contains')"
               placeholder="Search Results" />
      </span>
      <button pButton type="button"
              class="p-button-sm refresh-btn"
              icon="pi pi-refresh"
              label="Refresh"
              [disabled]="loading || !executionId"
              (click)="refreshDetails()"></button>
    </div>
  </div>

  <p-table
    #dt
    [value]="details"
    [globalFilterFields]="['accountLabel','user','campaignAdGroupName','result']"
    responsiveLayout="scroll"
    [paginator]="true"
    [rows]="20"
    styleClass="exec-details-p-table p-datatable-sm p-datatable-striped">
    <ng-template pTemplate="header">
      <tr>
        <th class="col-account">Account</th>
        <th class="col-user">User</th>
        <th class="col-campaign">Campaign/Ad Group</th>
        <th class="col-start">Start</th>
        <th class="col-complete">Complete</th>
        <th class="col-result">Result</th>
        <th class="col-error">Error Message</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-row>
      <tr>
        <td class="col-account">
          <span *ngIf="row.accountName; else accountNoName">{{ row.accountName }} ({{ row.accountId }})</span>
          <ng-template #accountNoName>Account ({{ row.accountId }})</ng-template>
        </td>
        <td class="col-user">{{ row.user }}</td>
        <td class="col-campaign">{{ row.campaignAdGroupName }}</td>
        <td class="col-start">
          <ng-container *ngIf="row.started; else noStart">
            <ng-container *ngIf="row.started?.date; else startedSimple">{{ row.started?.date.toLocaleString()  | date: 'short' }}</ng-container>
            <ng-template #startedSimple>{{ row.started.toLocaleString() | date: 'short' }}</ng-template>
          </ng-container>
          <ng-template #noStart>-</ng-template>
        </td>
        <td class="col-complete">
          <ng-container *ngIf="row.completed; else noComplete">
            <ng-container *ngIf="row.completed?.date; else completedSimple">{{ row.completed?.date.toLocaleString()  | date: 'short' }}</ng-container>
            <ng-template #completedSimple>{{ row.completed | date: 'short' }}</ng-template>
          </ng-container>
          <ng-template #noComplete>-</ng-template>
        </td>
        <td class="col-result">
          <ng-container *ngIf="row.result; else noResult">
            <span [ngClass]="{
              'result-succeeded': row.result === 'Succeeded',
              'result-skipped': row.result === 'Skipped',
              'result-failed': row.result === 'Failed',
              'result-in-progress': row.result === 'In Progress' || row.result === 'Started',
              'result-not-started': row.result === 'Not Started'
            }">{{ row.result }}</span>
          </ng-container>
          <ng-template #noResult>-</ng-template>
        </td>
        <td class="col-error">
          <ng-container *ngIf="row.errorMessage && row.errorMessage.trim().length > 0; else noError">
            <button pButton type="button" class="p-button-text p-button-sm view-error-btn" (click)="openErrorDialog(row)" label="View Error(s)"></button>
          </ng-container>
          <ng-template #noError>-</ng-template>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td class="empty" colspan="7">
          <span *ngIf="!loading && !executionId">Select an execution above to see details</span>
          <span *ngIf="!loading && executionId">No details found for this execution.</span>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <p-dialog
    [(visible)]="errorDialogVisible"
    [modal]="true"
    [closable]="true"
    [dismissableMask]="true"
    [draggable]="false"
    [style]="{width: '650px', maxWidth: '95vw'}"
    [contentStyle]="{'max-height':'20vh','overflow':'auto'}"
    [header]="errorDialogTitle">
    <div class="error-dialog-body">
      <ul class="error-list" *ngIf="errorDialogMessages?.length; else singleMessage">
        <li *ngFor="let msg of errorDialogMessages" [style]="{'margin':'0.5rem 0'}">{{ msg }}</li>
      </ul>
      <ng-template #singleMessage>
        <div class="single-error" *ngIf="errorDialogSingleMessage" [style]="{'margin':'0.5rem 0'}">{{ errorDialogSingleMessage }}</div>
        <div *ngIf="!errorDialogSingleMessage">No error message provided.</div>
      </ng-template>
    </div>
  </p-dialog>
</div>
